import { Component, OnInit, Output, ViewChild, EventEmitter, Input, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoryService } from 'src/app/_services/category.service';
import { UsersAndGroupsService } from 'src/app/_services/users-and-groups.service';
import { VirtualFolderService } from 'src/app/_services/virtualFolder.service';
import { RuleModel,  ColumnsModel, TemplateColumn, QueryBuilder } from '@syncfusion/ej2-angular-querybuilder';
import { Browser } from '@syncfusion/ej2-base';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { User } from '../../_models';
import { AppConfig } from 'src/assets/config/config/app-config';


@Component({
  selector: 'app-virtual-folders-config',
  templateUrl: './virtual-folders-config.component.html',
  styleUrls: ['./virtual-folders-config.component.scss']
})
export class VirtualFoldersConfigComponent implements OnInit {

  @Input() isCreateFolder: any;
  @Input() isUpdateFolder: any;
  @Input() isCreateSubFolder: any
  @Input() selectedFolderId: any;
  @Output() isMainPage = new EventEmitter<boolean>();
  allCategories = []
  createFormData: FormGroup
  fetchedFolderId: any;
  fetchedParentId: any
  allCategoryProperties = []
  searchCtrl: string = "";
  allGroups: string[] = [];
  query: any
  folder: any
  isFolderCreated: boolean = false
  public filter: ColumnsModel[];
  public paymentTemplate: TemplateColumn;
  public inOperators: string[] = ['in', 'notin'];
  public showButtons: Object = { groupInsert: false, groupDelete: true, ruleDelete: true }
  criteriaQuery: any;
  fetchedFolderName: string
  properties = []
  displayInList = []
  fetchedGroups: string[] = [];
  currentUser: User;
  showOwner: boolean = false
  userGroups: string[]
  isAdmin: boolean = false
  isDjango: boolean

  public data: Object[];
  public importRules: RuleModel;
  @ViewChild('querybuilder')
  qryBldrObj: QueryBuilder = new QueryBuilder({
    allowValidation: true
  });

  constructor(
    private fb: FormBuilder,
    private categoryService: CategoryService,
    private virtualFolderService: VirtualFolderService,
    private groupService: UsersAndGroupsService,
    private authenticationService: AuthenticationService,
    private cdref: ChangeDetectorRef,
    private config: AppConfig
  ) {

    this.currentUser = this.authenticationService.currentUserValue;
    this.userGroups = this.authenticationService.userGroupsValue;
    this.isDjango = this.config.getConfig('isDjango')
    this.createFormData = this.fb.group({
      folder_name: ['', Validators.required],
      category_id: ['', Validators.required],
      search: [''],
      display_list: ['', Validators.required],
      groups: ['', Validators.required],
      personal: [false],
      owner: ['']
    })
  }

  ngOnInit() {
    this.categoryService.getAll().subscribe(resp => {
      this.allCategories = resp['results']
    })
    var adminGroup
    var adminGroup
    this.groupService.getAdminGroupName().subscribe(admin => {
      adminGroup = admin
      this.userGroups.forEach(userGroup => {
        if (userGroup == adminGroup) {
          this.isAdmin = true
        }
      })

      if (!this.isAdmin) {
        this.fetchedGroups = this.userGroups
        this.allGroups = this.userGroups
      } else {
        this.groupService.getAllGroups().subscribe(groups => {
          if (this.isDjango) {
            this.fetchedGroups = groups
            this.allGroups = groups
            } else {
            this.fetchedGroups = [];
            this.allGroups = [];
            for (var i = 0; i < groups.Users.length; i++) {
              this.fetchedGroups.push(groups.Users[i].Username)
              this.allGroups.push(groups.Users[i].Username)
            }
          }
          console.log(this.fetchedGroups)
        });
      }
    })

    if (this.selectedFolderId) {
      this.virtualFolderService.getFolderDetails(this.selectedFolderId).subscribe(folder => {
        this.fetchedFolderName = folder.folder_name
        this.fetchedFolderId = folder.id
        this.fetchedParentId = folder.parent_id
        if (this.isUpdateFolder) {
          this.setUpdateFormData(folder)
          this.getDisplayListData(folder.category_id)
        }

      });
    }

    this.qryBldrObj.appendTo('#querybuilder');

    this.filter = []
    for (let property of this.allCategoryProperties) {
      var newProp = "'" + property + "'"
      this.filter.push({
        field: newProp, label: property, type: "string", validation: { isRequired: true }, //template: 
        // {
        //   write: (args: { field: string }) => {
        //     this.properties.push(args.field)
        //     console.log("THIS.PROPER", this.properties)
        // },
        // }
      })
    }

    this.importRules = {
      'label': 'Property',
      'field': 'Property',
      'type': 'string',
      'operator': 'equal',
      'value': ''

    };
  }

  ngAfterContentChecked() {
    //this.selectedRow = undefined
    this.cdref.detectChanges();
  }


  setUpdateFormData(folder) {

    this.properties = folder.display_list
    var data = {
      folder_name: folder.folder_name,
      category_id: folder.category_id,
      display_list: folder.display_list,
      search: folder.search,
      groups: folder.groups,
      personal: folder.personal,
      owner: folder.owner,
    }
    this.createFormData.patchValue(data)
  }


  queryBuilder() {
    this.properties = []
    this.displayInList = []
    this.criteriaQuery = this.qryBldrObj.getSqlFromRules(this.qryBldrObj.getRules())
    console.log(this.criteriaQuery.split("'"))
    this.criteriaQuery.split("'").forEach((element, index) => {
      if (index % 2 != 0) {
        this.displayInList.push(element)

      }
    });

    this.displayInList.forEach((element, index) => {
      if (index % 2 == 0) {
        this.properties.push(element)
      }
    });

    this.properties = this.properties.filter((elem, i, arr) => {
      if (arr.indexOf(elem) === i) {
        return elem
      }
    })

    this.qryBldrObj.validateFields();
    this.criteriaQuery = this.qryBldrObj.getSqlFromRules(this.qryBldrObj.getRules())
    //console.log("THIS IS QUERY", this.criteriaQuery)
    var meta_data = "meta_data->'properties'->>"
    var temp = []
    var criteria = ""
    var my_str = this.criteriaQuery
    var regexUnderscore = new RegExp("/AND/g"); //indicates global match
    var regexHash = new RegExp("/OR/ ", "g");

    // criteria = this.criteriaQuery.replace(regexHash, regexHash+meta_data).replace(regexUnderscore, regexUnderscore+meta_data);
    // // var substrAND = "AND "
    // var susbstrOR = "OR "
    // criteria = meta_data + this.criteriaQuery.replace("AND", "ANDjhsdsfius")

    // criteria = meta_data + this.criteriaQuery.replace("OR", "OR"+meta_data)
    if (this.criteriaQuery.includes("AND")) {
      this.criteriaQuery = meta_data + this.criteriaQuery.split("AND").join("AND " + meta_data)

    }
    else if (this.criteriaQuery.includes("OR")) {
      this.criteriaQuery = meta_data + this.criteriaQuery.split("OR").join("OR " + meta_data)

    }
    else {
      this.criteriaQuery = meta_data + this.criteriaQuery
    }

    this.query = this.criteriaQuery
    this.createFormData.value['search'] = this.criteriaQuery
  }

  getDisplayListData(searchFormCategories) {
    this.allCategoryProperties = []
    for (let category of this.allCategories) {
      for (let selectedCategory of searchFormCategories) {
        if (category.id == selectedCategory) {
          for (let metaData of category.meta_data_definition) {
            if (metaData.active) {
              for (let property of metaData.properties) {
                this.allCategoryProperties.push(property.name)
              }
            }
          }
        }
      }
    }

    this.allCategoryProperties = this.allCategoryProperties.filter((elem, i, arr) => {
      if (arr.indexOf(elem) === i) {
        return elem
      }
    })
    this.filter = []
    for (let property of this.allCategoryProperties) {
      var newProp = "'" + property + "'"
      this.filter.push({
        field: newProp, label: property, type: "string", validation: { isRequired: true }
      })
    }
    this.importRules = {
      'label': 'Property',
      'field': 'Property',
      'type': 'string',
      'operator': 'equal',
      'value': ''

    };

  }
  dataBound() {
    const id = 'id';
    const rowIndexes: number[] = [];
    (this.qryBldrObj.dataSource as object[]).forEach((sdata, index) => {
    });

  }

  togglePersonal() {
    this.showOwner = !this.showOwner;
    if (this.showOwner) {
      this.createFormData.get("owner").enable();
    }
    else {
      this.createFormData.get("owner").disable();
    }
  }
  saveUpdateData(formData) {
    formData.id = this.fetchedFolderId
    formData.parent_id = this.fetchedParentId
    this.virtualFolderService.updateFolder(formData).subscribe(resp => {
      this.isFolderCreated = true
      console.log("Folder updated", resp)
    })
  }

  back(refresh) {
      this.isMainPage.emit(refresh);
      this.createFormData.reset()
  }

  saveCreateData(formData) {
    console.log("Create form data", this.createFormData.value['folder_name'])
    if (this.isCreateFolder == true) {
      formData.parent_id = 0
    }
    else if (this.isCreateSubFolder == true) {
      formData.parent_id = this.fetchedFolderId
    }
    if (formData.personal == true) {
      this.virtualFolderService.createFolder(formData).subscribe(resp => {
        this.isFolderCreated = true
        console.log("Folder created", resp)
      })
    }
    else {
      formData.personal = false
      this.virtualFolderService.createFolder(formData).subscribe(resp => {
        this.isFolderCreated = true
        console.log("Folder created", resp)
      })
    }

  }
  createdControl(): void {
    if (Browser.isDevice) {
      this.qryBldrObj.summaryView = true;
    }
    this.criteriaQuery = this.qryBldrObj.getPredicate(this.qryBldrObj.rule)
  }

  getValue() {
    this.properties = []
    this.displayInList = []
    this.criteriaQuery = this.qryBldrObj.getSqlFromRules(this.qryBldrObj.getRules())
    this.criteriaQuery.split("'").forEach((element, index) => {
      if (index % 2 != 0) {
        this.displayInList.push(element)

      }
    });

    this.displayInList.forEach((element, index) => {
      if (index % 2 == 0) {
        this.properties.push(element)
      }
    });

    this.properties = this.properties.filter((elem, i, arr) => {
      if (arr.indexOf(elem) === i) {
        return elem
      }
    })
  }

}
